import { fetchFirestoreUserObjectPublic } from "@src/utility_functions/database_operations/users/readUser/fetchFirestoreUserObjectPublic";
import { fetchFirestoreUserObjectPrivate } from "@src/utility_functions/database_operations/users/readUser/fetchFirestoreUserObjectPrivate";
import {
  formatUserDocumentPublic,
  formatUserDocumentPrivate,
} from "#shared/formatDocument/formatUserDocument.js";
import { mergeTwoObjects } from "#root/shared/utility_functions/object_functions.js";

export const fetchUserDocument = async ({ queryKey }) => {
  try {
    const userObjectPublic = await fetchFirestoreUserObjectPublic(queryKey[1]);
    const userObjectPublicFormatted =
      formatUserDocumentPublic(userObjectPublic);
    if (queryKey[1] === queryKey[2]) {
      const userObjectPrivate = await fetchFirestoreUserObjectPrivate(
        queryKey[1],
      );
      const userObjectPrivateFormatted =
        formatUserDocumentPrivate(userObjectPrivate);
      const mergedUserObject = mergeTwoObjects(
        userObjectPublicFormatted,
        userObjectPrivateFormatted,
        ["profilePicture", "birthday"],
      );
      return mergedUserObject;
    }
    return userObjectPublicFormatted;
  } catch (error) {
    console.warn(error);
    return null;
  }
};
